module.exports = __webpack_public_path__ + "img/Group 863.fdad6491.png";